import { render } from "./ReviewContent.vue?vue&type=template&id=9b186b4c"
import script from "./ReviewContent.vue?vue&type=script&lang=js"
export * from "./ReviewContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__